import React from 'react';
import * as Icon from "react-feather";

const Smalltitle = ({title, icon}) => {
    return (  
        <div className="mi-smalltitle">
            <span className="mi-smalltitle-icon">
                {icon === 'briefcase' ? <Icon.Briefcase /> : <Icon.Book />}
            </span>
            <p className="font-weight-bold h5 mb-0">{title}</p>
        </div>
    );
}
 
export default Smalltitle;